import { useTranslation } from "react-i18next";
import { formatIntlNumber, getMinBudget } from "../../../../../utils/Helpers";

import { BOOKING_STEPS } from "../../utils/constants";
const { STEP_PREVIEWS_NEW, STEP_BEWERBERHUB, STEP_BASE_DATA, STEP_REVIEW } = BOOKING_STEPS;

function useDisableCampaignCreation({
  bookingStyle,
  lifeTimeBudget,
  campaignDuration,
  currentStep,
  selectedChatbotQuestion,
  adErrors,
  disabledBooking,
  language
}) {
  let isDisabled = false;
  let disabledMessage = "";
  const { t } = useTranslation();

  // If the budget is below the minimum budget then disable going to the next step
  if (
    currentStep !== STEP_BASE_DATA &&
    bookingStyle === "new" &&
    (isNaN(lifeTimeBudget) || lifeTimeBudget < getMinBudget(campaignDuration))
  ) {
    isDisabled = true;
    disabledMessage = t("Campaign budget must be at least {{amount}} €", {
      amount: formatIntlNumber(getMinBudget(campaignDuration), { language })
    });
  }

  // If there is no selected chatbot question then don't move on to the review step
  if (currentStep === STEP_BEWERBERHUB && !selectedChatbotQuestion) {
    isDisabled = true;
    disabledMessage = t("Select an automatic chatbot message");
  }

  if (currentStep === STEP_PREVIEWS_NEW) {
    const hasErrors = adErrors.length > 0;

    isDisabled = hasErrors;
    disabledMessage = hasErrors && adErrors[0].errorMessage;
  }

  if (currentStep === STEP_REVIEW && disabledBooking) {
    isDisabled = true;
    disabledMessage = t("Please provide a billing address");
  }

  return { isDisabled, disabledMessage };
}

export default useDisableCampaignCreation;
